import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HostedGameApplicationsService } from '@hosted-games/infra';
import { RejectApplicationsPathParams, RejectManyGamePlayerApplicationsDto } from '@core-http';

export class RejectApplicationsCommandHandler {
  private readonly hostedGameApplicationsService: HostedGameApplicationsService = inject(HostedGameApplicationsService);

  reject(gameId: string, applicationIds: string[]): Observable<void> {
    const pathParams: RejectApplicationsPathParams = { hostedGameId: gameId };
    const payload: RejectManyGamePlayerApplicationsDto = { gamePlayerApplicationIds: applicationIds };

    return this.hostedGameApplicationsService.rejectApplications(pathParams, payload);
  }
}
